module.exports = require("./scripts/index.js");


//////////////////
// WEBPACK FOOTER
// ./src/widget-hdfc-back-to-top/model.xml
// module id = 0
// module chunks = 2